const RELATION_LABELS = {
  SPOUSE: "Esposo(a)",
  CHILD: "Filho(a)",
  PARENT: "Pai/Mãe",
  SIBLING: "Irmão(ã)",
  GRANDPARENT: "Avô(ó)",
  GRANDCHILD: "Neto(a)",
  UNCLE: "Tio(a)",
  SIBLINGS_CHILD: "Sobrinho(a)",
  COUSIN: "Primo(a)",
  COMPANION: "Companheiro(a)",
};

export const translateRelationToPt = (relation) => {
  if (!relation) return null;
  return RELATION_LABELS[relation] || relation;
};
